import { HttpClient, HttpContext, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { API_BASE_URL } from '../shared/api/api.tokens';
import { REQUIRE_AUTH } from '../shared/interceptors/auth-context';
import { AnalyticsRequest, AnalyticsResponse } from '../shared/interfaces/analytics.interface';

@Injectable({ providedIn: 'root' })
export class AnalyticsService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = inject(API_BASE_URL);

  getAnalytics(request: AnalyticsRequest): Observable<AnalyticsResponse> {
    // Las fechas viajan en UTC (ISO con Z) y el desfase permite agrupar por día y hora local
    let params = new HttpParams()
      .set('startDate', new Date(request.startDate).toISOString())
      .set('endDate', new Date(request.endDate).toISOString())
      .set('timeZoneOffsetMinutes', String(-new Date().getTimezoneOffset()));

    if (request.professionalId) params = params.set('professionalId', request.professionalId);
    if (request.serviceId) params = params.set('serviceId', request.serviceId);
    if (request.clientId) params = params.set('clientId', request.clientId);
    if (request.statusCode) params = params.set('statusCode', request.statusCode);
    if (request.paymentMethod) params = params.set('paymentMethod', request.paymentMethod);

    return this.http.get<AnalyticsResponse>(
      `${this.baseUrl}/api/v1/reports/analytics`,
      {
        params,
        context: new HttpContext().set(REQUIRE_AUTH, true),
      }
    );
  }
}
